import React from "react";
import Select from "../../forms/select";

export const getCurrentVariation = (props, state) => {
  let result = { ...props.variations };
  let idx = 0;
  while (result && result.hasOwnProperty("index") && result.index.length > 0) {
    result = result.store[state[props.variates[idx].id]];
    idx++;
  }
  return !result || (result.index && result.index.length == 0)
    ? {
        prices: {},
      }
    : result;
};

export const getCurrentVariationHOC = (props) => {
  const defaultNoVariation = {
    prices: {},
  };
  if (!props.variations || props.variations.length == 0)
    return defaultNoVariation;
  let result = { ...props.variations[props.defaultVariationGroup].list };
  let _defaults = props.variations[props.defaultVariationGroup].list._defaults;
  let idx = 0;
  while (result && result.hasOwnProperty("index") && result.index.length > 0) {
    result =
      result.store[
        _defaults[props.variates[props.defaultVariationGroup].list[idx].id]
      ];
    idx++;
  }
  return !result || (result.index && result.index.length == 0)
    ? defaultNoVariation
    : result;
};

export const VariationSelect = ({
  variations,
  variates,
  idx,
  state,
  setState,
}) => {
  if (variations.index.length == 0) return null;
  const changeHandler = (value) => {
    // validate values down the tree
    let newState = {
      ...state,
      [variates[idx].id]: value,
    };
    let current = variations.store[value];
    for (let i = idx + 1; i < variates.length; i++) {
      if (!current.store.hasOwnProperty(state[variates[i].id])) {
        // new parent does not have selected child so select new first child
        newState[variates[i].id] = current.index[0];
        current = current.store[current.index[0]];
      } else {
        current = current.store[state[variates[i].id]];
      }
    }
    setState(newState);
  };

  return (
    <React.Fragment>
      <li key={variates[idx].id}>
        <Select
          key={variates[idx].id}
          disabled={variations.index.length == 1}
          value={state[variates[idx].id]}
          label={variates[idx].displayName}
          onChange={changeHandler}
        >
          {variations.index.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Select>
      </li>
      {variations.store[state[variates[idx].id]].hasOwnProperty("index") && (
        <VariationSelect
          key={state[variates[idx].id]}
          variations={variations.store[state[variates[idx].id]]}
          variates={variates}
          idx={idx + 1}
          state={state}
          setState={setState}
        />
      )}
    </React.Fragment>
  );
};

export const NRCBalls = props => {
  if (!props.value) return null
  return <span style={{ display: 'inline-flex', marginLeft: '6px' }}>
    {[1, 2, 3].map(value => (
      value <= parseInt(props.value)
        ? <i key={value} className="fas fa-circle fa-xs" style={{ position: "relative", marginLeft: ".3em", fontSize: '0.625em' }} />
        : <i key={value} className="far fa-circle fa-xs" style={{ position: "relative", marginLeft: ".3em", fontSize: '0.625em' }} />
    ))}
  </span>
}
